import React from 'react';
import {
  SiJava,
  SiTypescript,
  SiSpringboot,
  SiQuarkus,
  SiJenkins,
  SiGithubactions,
  SiConcourse,
  SiDocker,
  SiKubernetes,
  SiAmazonaws,
  SiGit,
  SiApachemaven,
  SiGradle,
  SiMysql,
} from 'react-icons/si';
import { FaFistRaised } from 'react-icons/fa';

// For tech not in react-icons/si we use the Simple Icons CDN
// (k6 has an entry there); recolor to emerald to match the grid.
const cdn = (slug, color = '34d399') =>
  `https://cdn.simpleicons.org/${slug}/${color}`;

const Group = ({ title, children }) => (
  <div>
    <h3 className='font-mono text-zinc-400 text-sm uppercase tracking-widest mb-5'>
      <span className='text-accent'>#</span> {title}
    </h3>
    <div className='grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4'>{children}</div>
  </div>
);

const Card = ({ name, children }) => (
  <div className='group rounded-xl border border-zinc-800 bg-bg-elev p-5 text-center hover:border-accent/50 hover:-translate-y-1 transition-all duration-200 cursor-default'>
    <div className='h-12 mb-3 flex items-center justify-center group-hover:scale-110 transition-transform duration-200'>
      {children}
    </div>
    <p className='text-zinc-300 text-sm font-medium'>{name}</p>
  </div>
);

const IconReact = ({ Icon }) => <Icon className='w-10 h-10 text-accent' />;
const IconImg = ({ src, alt, mono = true }) => (
  <img
    src={src}
    alt={alt}
    className={`w-10 h-10 object-contain ${mono ? '' : 'opacity-90'}`}
  />
);

const Skills = () => {
  return (
    <section name='skills' className='w-full py-24 sm:py-32 bg-bg-alt'>
      <div className='container-narrow'>
        <p className='section-eyebrow'>03. What I work with</p>
        <h2 className='section-title'>Skills</h2>
        <div className='w-12 h-1 bg-accent rounded-full mb-12' />

        <div className='space-y-14'>
          <Group title='Languages & Backend'>
            <Card name='Java'><IconReact Icon={SiJava} /></Card>
            <Card name='TypeScript'><IconReact Icon={SiTypescript} /></Card>
            <Card name='Spring Boot'><IconReact Icon={SiSpringboot} /></Card>
            <Card name='Quarkus'><IconReact Icon={SiQuarkus} /></Card>
          </Group>

          <Group title='Test Automation'>
            <Card name='Karate'><IconReact Icon={FaFistRaised} /></Card>
            <Card name='Playwright'>
              <IconImg src='/icons/playwright.svg' alt='Playwright' />
            </Card>
            <Card name='k6'>
              <IconImg src={cdn('k6')} alt='k6 (performance testing)' />
            </Card>
            <Card name='Pact'>
              <span aria-hidden='true' className='inline-flex items-center justify-center h-10 px-2.5 rounded-md border-2 border-accent text-accent font-bold text-base tracking-tight'>
                Pact
              </span>
            </Card>
          </Group>

          <Group title='CI/CD, Containers & Cloud'>
            <Card name='Jenkins'><IconReact Icon={SiJenkins} /></Card>
            <Card name='GitHub Actions'><IconReact Icon={SiGithubactions} /></Card>
            <Card name='Concourse'><IconReact Icon={SiConcourse} /></Card>
            <Card name='Docker'><IconReact Icon={SiDocker} /></Card>
            <Card name='Kubernetes'><IconReact Icon={SiKubernetes} /></Card>
            <Card name='AWS'><IconReact Icon={SiAmazonaws} /></Card>
          </Group>

          <Group title='Toolchain'>
            <Card name='Git'><IconReact Icon={SiGit} /></Card>
            <Card name='Maven'><IconReact Icon={SiApachemaven} /></Card>
            <Card name='Gradle'><IconReact Icon={SiGradle} /></Card>
            <Card name='MySQL'><IconReact Icon={SiMysql} /></Card>
          </Group>
        </div>
      </div>
    </section>
  );
};

export default Skills;
